import { API_BASE, apiFetch } from "../../api/http";

export async function getTemplate(docType: "protocol" | "protective", jurisdiction: string): Promise<{ template: string }> {
  const res = await apiFetch(`${API_BASE}/api/template?docType=${encodeURIComponent(docType)}&jurisdiction=${encodeURIComponent(jurisdiction)}`, { method: "GET" });
  if (!res.ok) {
    const err = await res.json().catch(() => ({} as any));
    throw new Error(err.message || `Failed to load template (${res.status})`);
  }
  return res.json();
}


